import { render } from "./FormItem.vue?vue&type=template&id=b39d949a&scoped=true"
import script from "./FormItem.vue?vue&type=script&lang=js"
export * from "./FormItem.vue?vue&type=script&lang=js"

import "./FormItem.vue?vue&type=style&index=0&id=b39d949a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39d949a"]])

export default __exports__